export default {"src":"/_next/static/image/public/images/flags/flag_66.dc43ac9b19f7b0e89cc200941cfed958.svg","height":16,"width":24};